import { COMPANY_PROJECT_TYPES_ENUM } from '@woovi/roles';

import {
  defaultOrderNodeOpenPix,
  defaultOrderNodeWoovi,
  defaultClickPixAttribute,
} from './getScriptParams.tsx';
import { PLUGIN_TYPE } from '../PluginType.ts';

export type HostNodeConfig = {
  id: string;
  projectType: string;
  pluginType: string;
};

export const hostNodes: Record<string, HostNodeConfig> = {
  openpixOrder: {
    id: defaultOrderNodeOpenPix,
    projectType: COMPANY_PROJECT_TYPES_ENUM.WOOVI,
    pluginType: PLUGIN_TYPE.ORDER,
  },
  wooviOrder: {
    id: defaultOrderNodeWoovi,
    projectType: COMPANY_PROJECT_TYPES_ENUM.WOOVI,
    pluginType: PLUGIN_TYPE.ORDER,
  },
  wooviButton: {
    id: defaultClickPixAttribute,
    projectType: COMPANY_PROJECT_TYPES_ENUM.WOOVI,
    pluginType: PLUGIN_TYPE.BUTTON,
  },
};
